import type { FC } from "react";
import { useLocation } from "react-router";

import { useClientContext } from "~/contexts/client-context";
import type { LayoutV2, Pages } from "~/core";
import { HeaderV4 } from "~/features/headerV4/HeaderV4";
import { usePlayNowUrl } from "~/shared/utils/aff-integration";
import { useGtmContext } from "~/shared/utils/gtm-sdk/provider";
import { useAction } from "~/widgets/use-action";

export const MainHeaderV2: FC<{ data: LayoutV2 }> = ({ data }) => {
  const location = useLocation();
  const { gtm } = useGtmContext();
  const playNowUrl = usePlayNowUrl();
  const {
    playerID,
    language,
    availableLanguages,
    languages,
    hreflangAlternates,
  } = useClientContext();
  const redirectToRoom = (): void => {
    if (playNowUrl) {
      window.location.href = playNowUrl;
    }
  };

  const { callAction: onCallAction, isActionInactive } = useAction();
  const headerAnalytics = {
    clickHeaderMain(triggerUrl: string) {
      const triggerId = triggerUrl.replace(/^\/+|\/+$/g, "");
      gtm.clickHeaderMain({
        eventTime: new Date(),
        playerID,
        triggerId: triggerId === "promotions" ? "Features" : triggerId,
      });
    },
    clickHeaderSub(targetUrl: string) {
      const targetId =
        targetUrl
          .replace(/^\/|\/$/g, "")
          .split("/")
          .at(-1) ?? "";

      gtm.clickHeaderSub({
        eventTime: new Date(),
        playerID,
        targetId,
        // одна из кнопок Хедера в котором кликнули на элемент Выпадающего меню (пока только Features). Аналитика требует название кнопки как на сайте
        triggerId: "Features",
        screenName: "mainPage",
      });
    },
    createAccountHeader() {
      gtm.createAccountHeader({
        eventTime: new Date(),
        playerID,
        screenName: "signUp",
      });
      redirectToRoom();
    },
    loginHeader() {
      gtm.loginHeader({
        eventTime: new Date(),
        playerID,
        screenName: "logIn",
      });
      redirectToRoom();
    },
  };

  const getUrl = (detailedPage: Pages): string => {
    if (!detailedPage?.slug) {
      return `/`;
    }

    const { segment, slug } = detailedPage;
    if (segment) {
      return `/${segment}/${slug}`;
    } else {
      return `/${slug}`;
    }
  };
  const headerData = {
    ...data,
    language,
    availableLanguages: availableLanguages ?? [],
    languages: languages ?? [],
    hreflangAlternates,
  };
  return (
    <HeaderV4
      key={location.pathname}
      {...headerAnalytics}
      data={headerData}
      getUrl={getUrl}
      onCallAction={onCallAction}
      isActionInactive={isActionInactive}
    />
  );
};
